import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2l0 -6","key":"svg-0"}],["path",{"d":"M9 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0","key":"svg-1"}],["path",{"d":"M13 11v-4a4 4 0 1 1 8 0v4","key":"svg-2"}]]

const IconLockOpen2 = createReactComponent('outline', 'lock-open-2', 'LockOpen2', __iconNode);

export default IconLockOpen2;